import React from "react";
import { Col, Row } from "@folio/stripes/components";
import { AccordionSection } from "../../../AccordionSection";
import { RegistrationAgencySelect } from "../RegistrationAgencySelect";
export var AgencySection = function (_a) {
    var control = _a.control, open = _a.open, onToggle = _a.onToggle;
    return (React.createElement(AccordionSection, { id: "progress-report-agency", labelId: "ui-br-agency.outputs.progress-report.section.agency", open: open, onToggle: onToggle },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(RegistrationAgencySelect, { control: control, name: "registrationAgency", showLabel: false })))));
};
